/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ week: NonNullable<unknown> }} Plan_WeekInputs */

const en_plan_week = /** @type {(inputs: Plan_WeekInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Week ${i?.week}`)
};

const de_plan_week = /** @type {(inputs: Plan_WeekInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`KW ${i?.week}`)
};

/**
* | output |
* | --- |
* | "Week {week}" |
*
* @param {Plan_WeekInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const plan_week = /** @type {((inputs: Plan_WeekInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Plan_WeekInputs, { locale?: "en" | "de" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_plan_week(inputs)
	return en_plan_week(inputs)
});